module.exports = __webpack_public_path__ + "img/kr.a04d3112.svg";